"use client"

import React, { createContext, ReactNode, useState, useEffect, useContext } from 'react';

interface ThemeContextProps {
    darkMode: boolean;
    toggleTheme: () => void;
}

export const ThemeContext = createContext<ThemeContextProps | undefined>(undefined);

interface ThemeProviderProps {
    children: ReactNode;
}

export const ThemeProvider = ({ children }: ThemeProviderProps) => {
    // Always use light theme - disabled dark mode functionality
    const [darkMode, setDarkMode] = useState(false);
    
    // No useEffect needed since we're always using light theme
    
    // Disabled toggle function - always returns false (light theme)
    const toggleTheme = React.useCallback(() => {
        // Theme toggling is disabled - always stays in light mode
        console.log("Theme toggling is disabled - staying in light mode");
    }, []);

    return (
        <ThemeContext.Provider value={React.useMemo(() => ({ darkMode, toggleTheme }), [darkMode, toggleTheme])}>
            {children}
        </ThemeContext.Provider>
    );
};


export const useTheme = () =>{
    const themeContext = useContext(ThemeContext);

    if (!themeContext) {
      throw new Error('ThemeContext must be used within a ThemeProvider');
    }
  
    return themeContext;
}

